import React from 'react';
import { Badge } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import { useTranslation } from '../../../common/hooks/useTranslation';

interface PlaceholderBadgeProps {
  tag: string;
  description: string;
  isCopied: boolean;
  onCopy: (tag: string) => void;
  isRequired: boolean;
}

export const PlaceholderBadge: React.FC<PlaceholderBadgeProps> = ({
  tag,
  description,
  isCopied,
  onCopy,
  isRequired,
}) => {
  const { t, tk } = useTranslation('administrationLng');
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    <div
      role="button"
      tabIndex={0}
      className="d-flex align-items-center gap-3 p-3 border border-dark border-1 rounded-3 h-75"
      onClick={() => onCopy(tag)}
    >
      <div className="d-flex align-items-center gap-2 mt-1">
        <code className="fw-semibold text-dark fs-5">{tag}</code>
        {isRequired && (
          <Badge bg="warning" text="dark" className="px-2 ms-2">
            {t(tk.survey.requiredShort)}
          </Badge>
        )}
        — {description}
      </div>
      <div>
        {isCopied ? (
          <Icon.Check size={20} className="text-success" />
        ) : (
          <Icon.Copy size={14} className="text-muted" />
        )}
      </div>
    </div>
  );
};
